import script from "./whatsapp-button.vue?vue&type=script&setup=true&lang=js"
export * from "./whatsapp-button.vue?vue&type=script&setup=true&lang=js"

import "./whatsapp-button.vue?vue&type=style&index=0&id=a1dce150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1dce150"]])

export default __exports__